import apiClient from './meta-client';
import type {
  BuilderItem,
  BuilderItemCreatePayload,
  BuilderItemUpdatePayload,
} from '@/types/template-builder';

export const listBuilderItems = async (
  projectId?: number | null,
): Promise<{ items: BuilderItem[]; total: number }> => {
  const params: Record<string, any> = {};
  if (projectId != null) params.project_id = projectId;
  const { data } = await apiClient.get('/template-builder/items', { params });
  return data;
};

export const createBuilderItem = async (
  payload: BuilderItemCreatePayload,
): Promise<BuilderItem> => {
  const { data } = await apiClient.post('/template-builder/items', payload);
  return data;
};

export const updateBuilderItem = async (
  id: number,
  changes: BuilderItemUpdatePayload,
): Promise<BuilderItem> => {
  const { data } = await apiClient.patch(`/template-builder/items/${id}`, changes);
  return data;
};

export const deleteBuilderItem = async (id: number): Promise<{ ok: boolean }> => {
  const { data } = await apiClient.delete(`/template-builder/items/${id}`);
  return data;
};

export const submitBuilderItem = async (id: number): Promise<BuilderItem> => {
  const { data } = await apiClient.post(`/template-builder/items/${id}/submit`);
  return data;
};

export const batchSubmitBuilderItems = async (
  ids: number[],
  pageId: string,
): Promise<{ submitted: number; total: number; results: Array<{ id: number; ok: boolean; error?: string }> }> => {
  const { data } = await apiClient.post('/template-builder/items/batch-submit', { ids, page_id: pageId });
  return data;
};

export const getBuilderApprovalStatus = async (id: number): Promise<BuilderItem> => {
  const { data } = await apiClient.get(`/template-builder/items/${id}/approval-status`);
  return data;
};

export const confirmBuilderItem = async (id: number): Promise<BuilderItem> => {
  const { data } = await apiClient.post(`/template-builder/items/${id}/confirm`);
  return data;
};

export const testSendBuilderItem = async (
  id: number,
  leadId: number,
): Promise<{ ok: boolean; detail?: any }> => {
  const { data } = await apiClient.post(`/template-builder/items/${id}/test-send`, {
    lead_id: leadId,
  });
  return data;
};
